export const endPoint = 'https://api-gateway.cedrict.com:80/api/v1'
export const mockEndPoint = 'http://localhost:3100/api/v1'